/**
 * External dependencies
 */
import React, { useMemo } from "react";
import classNames from "classnames";

/**
 * Internal dependencies
 */
import FeaturedImage from "./FeaturedImage";

/**
 * Configuration
 */
import config from "../config";
const { texts } = config;

const NewsCard = ({
	title,
	link,
	featured_image,
	date,
	content,
	themes,
	themeData,
}) => {
	const componentClass = classNames(
		"post-card",
		"animated",
		"duration--fast",
		"fadeIn"
	);
	if (themeData instanceof Object) {
		themeData = Object.values(themeData);
	}
	const terms = useMemo(
		() => themeData.filter(({ id }) => themes.includes(id)),
		[themes, themeData]
	);

	return (
		<article className={componentClass}>
			<a href={link} className="post-card__link">
				<div className="post-card__meta">
					<div className="post-card__category">
						{terms.map(({ name }, index) => (
							<span key={index}> 
								{name}  
								{index !== terms.length - 1 && ' / '}
							</span>
						))}
					</div>
				</div>
				<div className="post-card__image">				
					<figure className="wp-block-image">
						<FeaturedImage image={featured_image} size="medium_large" />
					</figure>
				</div>
				<div className="post-card__content">
					<h3 className="post-card__title">{title}</h3>
					<div className="post-card__excerpt">
						{content}         
					</div>
					<div className="post-card__footer">
						<div className="post-card__cta">
							<div className="wp-block-button is-style-arrow">
								<span className="wp-block-button__link has-burgundy-color has-text-color">{texts?.read_more}</span>
							</div>
						</div>
					</div>
				</div>
			</a>
		</article>
	);
};

export default NewsCard;
